<mat-drawer-container fullscreen class="drawer-container">
    <mat-drawer-content id="mat-drawer-content">
        <!--VNEXT-390: KLW - Bind the selectionSet emitter to correctly set selected items-->
        <app-list-view class="workflow-list-container"
                       [list]="this.ListItems"
                       [title]="'Workflow Catalog'"
                       [heading]="'Workflow Catalog'"
                       [buttonConfig]="this.ButtonConfig"
                       [columnsConfig]="['select', 'name', 'modifiedDate', 'modifiedBy']"
                       (editClick)="doOnEdit($event)"
                       (itemActionClick)="doOnItemAction($event)"
                       (buttonClick)="doOnButtonClick($event)"
                       (itemDeleted)="doOnItemDelete($event)"
                       (itemContextMenu)="doOnItemContextMenu($event)"
                       (selectionsSet)="this.setSelections($event)">
        </app-list-view>

        <!-- 10-22-2022 note:  need to discuss the workflow delete logic with Kevin prior to depending upon the following context menu component. -->
        <app-context-menu #itemContextMenuComponent
                          [contextMenuData]="this.ItemContextMenuData"
                          [menuName]="'itemContextMenuComponent'"
                          style="visibility: hidden; position: fixed"></app-context-menu>

        <div style="visibility: hidden; position: fixed"
             [style.left]="this.ContextMenuPositionX"
             [style.top]="this.ContextMenuPositionY"
             [matMenuTriggerFor]="itemContextMenu">
        </div>

        <mat-menu #itemContextMenu="matMenu">
            <button mat-menu-item
                    [disabled]="false"
                    (click)="doOnOpenItemClick($event)">
                Open
            </button>
            <button mat-menu-item
                    [disabled]="!this.UserCanDelete"
                    (click)="doOnDeleteItemClick($event)">
                Delete ...
            </button>
        </mat-menu>
    </mat-drawer-content>

    <mat-drawer #drawer
                mode="over"
                position="end"
                [opened]="this.ShowEditPropertiesDrawer"
                (closedStart)="this.drawerClosing()">
        <!-- Drawer header content. -->
        <mat-toolbar>
            <span>{{this.DetailsDrawerTitle}}</span>
            <span class="info-drawer-toolbar-spacer"></span>
            <button mat-icon-button (click)="this.closeDrawerClicked()" tabindex="-1"><mat-icon>close</mat-icon></button>
        </mat-toolbar>
        <div id="details-drawer-keyboard-focus-div" tabindex="-1"></div>

        <!-- Drawer body content. -->
        <app-workflow-details *ngIf="this.ShowEditPropertiesDrawer"
                              [workflow]="this.SelectedWorkflow"
                              (save)="this.doOnWorkflowSave($event)"
                              (close)="this.doOnWorkflowPropertiesClose($event)"></app-workflow-details>
    </mat-drawer>
</mat-drawer-container>
